export default "__VITE_ASSET__BfGhGvVX__"